"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PagePicture = _interopRequireDefault(require("../../PagePicture/PagePicture"));
var _Logo = require("../../../Logo/Logo");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-newsletter .newsletter-top {\n  display: flex;\n  flex-direction: column;\n  max-width: 765px; }\n  .sia-newsletter .newsletter-top .top {\n    display: flex;\n    align-self: center;\n    justify-content: center;\n    width: 100vw;\n    background-color: #e8e8e8; }\n    .sia-newsletter .newsletter-top .top .picture-container {\n      max-width: 733px; }\n  .sia-newsletter .newsletter-top .logo-container {\n    display: flex;\n    gap: 24px;\n    align-items: flex-end; }\n    .sia-newsletter .newsletter-top .logo-container p {\n      line-height: 100%; }\n";
  const fileName = "SIANewsletterTop_SIANewsletterTop";
  const element = document.querySelector("style[data-sass-component='SIANewsletterTop_SIANewsletterTop']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIANewsletterTop = _ref => {
  let {
    item
  } = _ref;
  const date = item.send_time[0]?.value?.split(' ')[0];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "newsletter-top sia-padding-02-inline"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "top sia-padding-04-top "
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: item.banner[0].link.original_url,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      maxWidth: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_PagePicture.default, {
    src: item.banner[0].picture[0]?.desktop.url,
    aspectRatio: "640/100"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-border-01-bottom sia-padding-03-bottom "
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "logo-container sia-margin-03-top sia-margin-02-left"
  }, /*#__PURE__*/_react.default.createElement(_Logo.Logo, {
    claim: false,
    className: 'header__logo-small without-claim'
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-06"
  }, item.title, " ", item.sia_newsletter_labels['cms.newsletter.from'], ' ', date))));
};
var _default = exports.default = SIANewsletterTop;